import React, { Component } from 'react';
import { Header, Popup, Icon } from 'semantic-ui-react'
import FormatCurrency from "../FormatCurrency"

export default class AccountHeader extends Component {

    render() {
        return (
            <Header attached='top' block>
                <div className="divLeft14" >
                    {this.props.status.toUpperCase()}&nbsp;     
                    <Popup position='top center' trigger={<Icon link circular name='info' className='accountIcon' />} on='click' hideOnScroll wide>
                    <p>
                        {this.props.status_info}
                    </p>
                    </Popup>
                   
                    <span className="divRight">
                        <FormatCurrency amount={this.props.total_enrolled} />                        
                    </span> 
                </div>

                {this.props.total_original_amount > 0 &&
                    <div className="divItalicLeft12">          
                        &nbsp;              
                        <span className="divItalicRight13">
                            Original Total:&nbsp;                            
                            <FormatCurrency amount={this.props.total_original_amount} />
                        </span>
                    </div>
                }
            </Header>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/AccountHeader/index.js